/* eslint-disable
    default-case,
    one-var,
    prefer-const
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import reactUpdate, {Spec} from 'immutability-helper';

import {assert} from 'Asserts';
import {EventConstants} from 'constants/EventConstants';
import AppDispatcher, {FluxAction} from 'lib/Dispatcher';
import Store from 'lib/Store';
import {
  FromServerId,
  FromServerProtocol,
  Protocol,
  ProtocolVersion,
  VersionSummary,
} from 'notebook/ELNConstants';
import ProtocolStoreTransforms, {ToServerProtocol} from 'notebook/protocols/ProtocolStoreTransforms';
import VersionedItemSubstore, {ItemEditorState, ItemVersionState} from 'notebook/store/VersionedItemSubstore';
import {MultidocTableOpMap} from 'notebook/tables/excess/ops/TableOpConstants';
import {NotePart} from 'notebook/util/NoteUtilConstants';
import notifications, {Response} from 'notifications';
import {ArrayElement} from 'util/Types';

import ProtocolUpdater from '../ProtocolUpdater';

type ProtocolItemSubstore = VersionedItemSubstore<
  Protocol,
  NotePart,
  FromServerProtocol,
  VersionSummary<FromServerId>,
  'protocol',
  'protocolID'
>;

export type ProtocolEditorState = ItemEditorState<Protocol, NotePart, 'protocol', 'protocolID'>;
export type ProtocolVersionState = ItemVersionState<VersionSummary<FromServerId>>;

interface LazyEditorActions {
  save: (protocolID: string) => JQueryPromise<boolean>;
  update: (protocolID: string, op: Spec<Protocol>, options?: {bumpVersion?: boolean}) => void;
}

// Store for a collection of Protocols
class EditorStore extends Store {
  itemSubstore!: ProtocolItemSubstore;

  postSanitizeItem(
    id: string,
    newProtocol: Protocol,
    oldProtocol: Protocol | null,
    {bumpVersion}: {bumpVersion?: boolean}
  ): Protocol {
    const updater = new ProtocolUpdater(
      id,
      () => this.itemSubstore.getItem(id),
      (protocolVersion: ProtocolVersion, _asyncMultidocTableOp: MultidocTableOpMap) => {
        const EditorActions: LazyEditorActions = require('notebook/protocols/actions/EditorActions').default;
        EditorActions.update(id, {$merge: protocolVersion}, {bumpVersion});
      },
      {multidocTableOp: {[id]: 'eval-document-unsupported'}}
    );
    return updater.run(newProtocol, oldProtocol);
  }

  override resetState(): void {
    if (this.itemSubstore == null) {
      this.itemSubstore = new VersionedItemSubstore({
        options: {
          idKey: 'protocolID',
          itemKey: 'protocol',
          friendlyItemName: 'protocol',
          asyncItemLoad: true,
          sanitizeItem: ProtocolStoreTransforms.sanitizeProtocol.bind(ProtocolStoreTransforms),
          postSanitizeItem: this.postSanitizeItem.bind(this),
          prepareForStore: ProtocolStoreTransforms.prepareForStore.bind(ProtocolStoreTransforms),
          pickRevertableFields: ProtocolStoreTransforms.pickRevertableFields.bind(ProtocolStoreTransforms),
          doSave(id: string): JQueryPromise<boolean> {
            const EditorActions: LazyEditorActions =
              require('notebook/protocols/actions/EditorActions').default;
            return EditorActions.save(id);
          },
        },
        events: {
          item: {
            load: {
              init: EventConstants.EDITOR_OPEN,
              completed: EventConstants.EDITOR_OPEN_COMPLETED,
              failed: EventConstants.EDITOR_OPEN_FAILED,
            },
            close: EventConstants.EDITOR_CLOSE,
            rename: EventConstants.FILE_BROWSER_RENAME_FILE,
            revert: EventConstants.EDITOR_REPLACE,
            update: EventConstants.EDITOR_UPDATE,
            registerObjects: EventConstants.EDITOR_REGISTER_OBJECTS,
            resetToOpenVersion: EventConstants.EDITOR_RESET_TO_OPEN_VERSION,
            save: {
              init: EventConstants.EDITOR_SAVE,
              completed: EventConstants.EDITOR_SAVE_COMPLETED,
              failed: EventConstants.EDITOR_SAVE_FAILED,
            },
            move: EventConstants.FILE_BROWSER_MOVE_FILES_COMPLETED,
          },
          version: {
            load: {
              init: EventConstants.EDITOR_LOAD_VERSION,
              completed: EventConstants.EDITOR_LOAD_VERSION_COMPLETED,
              failed: EventConstants.EDITOR_LOAD_VERSION_FAILED,
            },
          },
          versions: {
            fetch: {
              init: EventConstants.EDITOR_FETCH_VERSIONS,
              completed: EventConstants.EDITOR_FETCH_VERSIONS_COMPLETED,
              failed: EventConstants.EDITOR_FETCH_VERSIONS_FAILED,
            },
          },
        },
      });
    }
    this.itemSubstore.resetState();
  }

  prepareForSave(id: string, protocol: Protocol): ToServerProtocol {
    const {cidIdMap} = this.itemSubstore.getItemState(id)!;
    // Protocol types its steps with ClientId (`id?: never`) but prepareForStore leaves the server ids in
    // place, which is what prepareForSave reads. The two types contradict, so a plain cast is rejected.
    // @ts-expect-error ts(2345)
    return ProtocolStoreTransforms.prepareForSave(protocol, cidIdMap);
  }

  getEditorState(id: string): ProtocolEditorState {
    return this.itemSubstore.getEditorState(id);
  }

  getVersionState(id: string): ProtocolVersionState {
    return this.itemSubstore.getVersionState(id);
  }

  hasUnsavedChanges(id: string): boolean {
    return this.itemSubstore.hasUnsavedChanges(id);
  }

  override payloadHandler(action: FluxAction): boolean {
    let error: Response,
      newSteps: Protocol['steps'],
      protocol: Protocol,
      protocolID: string | undefined,
      stepID: number;
    let step: ArrayElement<Protocol['steps']>;
    // The substore reads its own events off the payload by key, so it types the parameter more loosely
    // than the dispatcher's discriminated union.
    let shouldEmit = this.itemSubstore.handlePayload(
      action as Parameters<ProtocolItemSubstore['handlePayload']>[0]
    );

    switch (action.actionType) {
      case EventConstants.EXCESS_DELETE_SNAPSHOTTED_RESOLUTIONS_FOR_TABLE: {
        const {itemId} = action;
        if (!this.itemSubstore.inStore(itemId)) {
          break;
        }
        assert(false, 'Protocol unexpectedly called refresh tables');
        break;
      }
      case EventConstants.PROTOCOL_DELETE_FAILED:
        ({protocolID, error} = action);
        if (this.itemSubstore.inStore(protocolID)) {
          notifications.notifyError(error);
        }
        break;

      case EventConstants.PROTOCOL_STEP_COMPLETE_COMPLETED:
        ({protocolID, stepID} = action);
        if (this.itemSubstore.inStore(protocolID)) {
          ({protocol} = this.itemSubstore.getItemState(protocolID)!);
          newSteps = (() => {
            const result = [];
            for (step of Array.from(protocol.steps)) {
              if (stepID !== step.id) {
                result.push(step);
              } else {
                result.push(reactUpdate(step, {$merge: {completed: true}}));
              }
            }
            return result;
          })();
          this.itemSubstore.mergeItem(protocolID, {steps: newSteps});
          shouldEmit = true;
        }
        break;

      case EventConstants.PROTOCOL_STEP_RESET_COMPLETED:
        ({protocolID, stepID} = action);
        if (this.itemSubstore.inStore(protocolID)) {
          ({protocol} = this.itemSubstore.getItemState(protocolID)!);
          newSteps = (() => {
            const result1 = [];
            for (step of Array.from(protocol.steps)) {
              if (stepID !== step.id) {
                result1.push(step);
              } else {
                result1.push(reactUpdate(step, {$merge: {completed: false}}));
              }
            }
            return result1;
          })();
          this.itemSubstore.mergeItem(protocolID, {steps: newSteps});
          shouldEmit = true;
        }
        break;
    }

    if (shouldEmit) {
      this.emitChange();
    }
    return true;
  }

  __serverBootstrapItem(object: {id: string; item: FromServerProtocol}): void {
    this.itemSubstore.__serverBootstrapItem(object);
  }
}

const editorStore = new EditorStore(AppDispatcher);

export default editorStore;
